import { EnvironmentConfig } from '../utils/getEnvironment/getEnvironment'
import { Environment } from '../utils/getEnvironment/types'
import { appSettings } from './appsettings'

const envConfig: EnvironmentConfig = {
  [Environment.LOCAL]: {
    apiEndpoint: appSettings.apiName,
    baseurl: '/',
    instrumentationKey: 'a0f8d9eb-fd2d-4d21-8451-ac1cc09ec97e',
    addressResolverBaseUrl: '/address-resolver-api/',
    geoFeaturesApi: '/geocode-api',
  },
  [Environment.PMDEV]: {
    apiEndpoint: `https://${appSettings.apiName}.pmdev.np.webapp.thameswater.co.uk/${appSettings.apiName}/`,
    baseurl: `https://${appSettings.appName}.pmdev.np.webapp.thameswater.co.uk/app/`,
    instrumentationKey: 'd95c285f-69fd-4d68-8cb4-353756efbbc1',
    addressResolverBaseUrl: 'https://address-resolver-api.pmdev.np.webapp.thameswater.co.uk/address-resolver-api/',
    geoFeaturesApi: 'https://geocode-api.pmdev.np.webapp.thameswater.co.uk/geocode-api/'
  },
  [Environment.PMQA]: {
    apiEndpoint: `https://${appSettings.apiName}.pmqa.np.webapp.thameswater.co.uk/${appSettings.apiName}/`,
    baseurl: `https://${appSettings.appName}.pmqa.np.webapp.thameswater.co.uk/app/`,
    instrumentationKey: '6fedca11-b12d-450e-aa94-98f1b565c660',
    addressResolverBaseUrl: 'https://address-resolver-api.pmqa.np.webapp.thameswater.co.uk/address-resolver-api/',
    geoFeaturesApi: 'https://geocode-api.pmqa.np.webapp.thameswater.co.uk/geocode-api'
  },
  [Environment.DEV]: {
    apiEndpoint: `https://${appSettings.apiName}.dev.np.webapp.thameswater.co.uk/${appSettings.apiName}/`,
    baseurl: `https://${appSettings.appName}.dev.np.webapp.thameswater.co.uk/app/`,
    instrumentationKey: 'a0f8d9eb-fd2d-4d21-8451-ac1cc09ec97e',
    addressResolverBaseUrl: 'https://address-resolver-api.dev.np.webapp.thameswater.co.uk/address-resolver-api/',
    geoFeaturesApi: 'https://geocode-api.dev.np.webapp.thameswater.co.uk/geocode-api'
  },
  [Environment.DEMO]: {
    apiEndpoint: `https://${appSettings.apiName}.demo.p.webapp.thameswater.co.uk/${appSettings.apiName}/`,
    baseurl: `https://${appSettings.appName}.demo.p.webapp.thameswater.co.uk/app/`,
    instrumentationKey: '4987e72b-5c3b-49ce-995e-ddd1c9ac2258',
    addressResolverBaseUrl: 'https://address-resolver-api.demo.p.webapp.thameswater.co.uk/address-resolver-api/',
    geoFeaturesApi: 'https://geocode-api.demo.p.webapp.thameswater.co.uk/geocode-api'
  },
  [Environment.PRODUCTION]: {
    apiEndpoint: `https://${appSettings.apiName}.prod.p.webapp.thameswater.co.uk/${appSettings.apiName}/`,
    baseurl: `https://${appSettings.appName}.prod.p.webapp.thameswater.co.uk/app/`,
    instrumentationKey: '2178da5f-e279-4e0d-8556-9be134c061a7',
    addressResolverBaseUrl: 'https://address-resolver-api.prod.p.webapp.thameswater.co.uk/address-resolver-api/',
    geoFeaturesApi: 'https://geocode-api.prod.p.webapp.thameswater.co.uk/geocode-api'
  }
}

export { envConfig }
